export default {
  "layout1-01": {
    rows: {
      1: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout2-01": {
    rows: {
      1: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout2-02": {
    rows: {
      1: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 41.67,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      2: {
        width: 58.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "calc(41.67% - calc(var(--cell-gap))) 58.33%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout2-03": {
    rows: {
      1: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 58.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      2: {
        width: 41.67,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "58.33% calc(41.67% - calc(var(--cell-gap)))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout2-04": {
    rows: {
      1: {
        columns: 1,
      },
      2: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      2: {
        width: 100,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-01": {
    rows: {
      1: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc(33.3333% - calc(2 / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-02": {
    rows: {
      1: {
        columns: 1,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-03": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 100,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-04": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 50,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-05": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout3-06": {
    rows: {
      1: {
        columns: 1,
      },
      2: {
        columns: 1,
      },
      3: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          }
        }
      },
      2: {
        width: 100,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          }
        }
      },
      3: {
        width: 100,
        order_mobile: 3,
        rowNo: 3,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc(33.3333% - calc(2 / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-01": {
    rows: {
      1: {
        columns: 4,
      },
    },
    cells: {
      1: {
        width: 25,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          }
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          }
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          }
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "04": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "04"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "04": "repeat(4, calc(25% - calc(3 / 4 * var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-02": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      4: {
        width: 50,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-03": {
    rows: {
      1: {
        columns: 1,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-04": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 100,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-05": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 50,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-06": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-07": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 66.67,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 66.67,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-08": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 66.67,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 66.67,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-09": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 66.67,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-10": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 66.67,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-11": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-12": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
      3: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 50,
        order_mobile: 4,
        rowNo: 3,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout4-13": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
      3: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      2: {
        width: 50,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      3: {
        width: 50,
        order_mobile: 2,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          }
        }
      },
      4: {
        width: 50,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          }
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-01": {
    rows: {
      1: {
        columns: 5,
      },
    },
    cells: {
      1: {
        width: 20,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      2: {
        width: 20,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      3: {
        width: 20,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      4: {
        width: 20,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      5: {
        width: 20,
        order_mobile: 5,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc((100% / 3) - calc((3 - 1) / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-02": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 25,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 50,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-03": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-04": {
    rows: {
      1: {
        columns: 1,
      },
      2: {
        columns: 4,
      },
    },
    cells: {
      1: {
        width: 100,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-05": {
    rows: {
      1: {
        columns: 4,
      },
      2: {
        columns: 1,
      },
    },
    cells: {
      1: {
        width: 25,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 100,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-06": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 50,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-07": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-08": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 33.33,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout5-09": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 33.33,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 3,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout6-01": {
    rows: {
      1: {
        columns: 6,
      },
    },
    cells: {
      1: {
        width: 16.66,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 16.66,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 16.66,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 16.66,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      5: {
        width: 16.66,
        order_mobile: 5,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      6: {
        width: 16.66,
        order_mobile: 6,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "03": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc((100% / 3) - calc((3 - 1) / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout6-02": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      5: {
        width: 33.33,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      6: {
        width: 33.33,
        order_mobile: 6,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "03": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc((100% / 3) - calc((3 - 1) / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout6-03": {
    rows: {
      1: {
        columns: 2,
      },
      2: {
        columns: 2,
      },
      3: {
        columns: 2,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 50,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 50,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 50,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 50,
        order_mobile: 5,
        rowNo: 3,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 50,
        order_mobile: 6,
        rowNo: 3,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout7-01": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
      3: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 25,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 7,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 3,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 4,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 25,
        order_mobile: 5,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      7: {
        width: 50,
        order_mobile: 6,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout7-02": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
      3: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 50,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 25,
        order_mobile: 6,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      7: {
        width: 25,
        order_mobile: 7,
        rowNo: 3,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout7-03": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
      3: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 12,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      3: {
        width: 33.33,
        order_mobile: 5,
        rowNo: 3,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      4: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 33.33,
        order_mobile: 6,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 12,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
        }
      },
      7: {
        width: 33.33,
        order_mobile: 7,
        rowNo: 13,
        cellGap: {
          top: false,
          right: false,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01"],
      gridTemplateColumns: {
        "01": "100%",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout8-01": {
    rows: {
      1: {
        columns: 4,
      },
      2: {
        columns: 4,
      },
    },
    cells: {
      1: {
        width: 25,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 25,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 25,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 25,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      5: {
        width: 25,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      6: {
        width: 25,
        order_mobile: 6,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      7: {
        width: 25,
        order_mobile: 7,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      8: {
        width: 25,
        order_mobile: 8,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "04": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "04"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "04": "repeat(4, calc(25% - calc(3 / 4 * var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout9-01": {
    rows: {
      1: {
        columns: 3,
      },
      2: {
        columns: 3,
      },
      3: {
        columns: 3,
      },
    },
    cells: {
      1: {
        width: 33.33,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 33.33,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 33.33,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 33.33,
        order_mobile: 4,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      5: {
        width: 33.33,
        order_mobile: 5,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: true,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      6: {
        width: 33.33,
        order_mobile: 6,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      7: {
        width: 33.33,
        order_mobile: 7,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      8: {
        width: 33.33,
        order_mobile: 8,
        rowNo: 3,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "03": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      9: {
        width: 33.33,
        order_mobile: 9,
        rowNo: 3,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "03": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "03"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "03": "repeat(3, calc(33.3333% - calc(2 / 3 *  var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout10-01": {
    rows: {
      1: {
        columns: 5,
      },
      2: {
        columns: 5,
      },
    },
    cells: {
      1: {
        width: 20,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 20,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 20,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 20,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      5: {
        width: 20,
        order_mobile: 5,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 20,
        order_mobile: 6,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      7: {
        width: 20,
        order_mobile: 7,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      8: {
        width: 20,
        order_mobile: 8,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      9: {
        width: 20,
        order_mobile: 9,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      10: {
        width: 20,
        order_mobile: 10,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "04"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "04": "repeat(4, calc(25% - calc(3 / 4 * var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
  "layout12-01": {
    rows: {
      1: {
        columns: 6,
      },
      2: {
        columns: 6,
      },
    },
    cells: {
      1: {
        width: 16.66,
        order_mobile: 1,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: false,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      2: {
        width: 16.66,
        order_mobile: 2,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      3: {
        width: 16.66,
        order_mobile: 3,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: false,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      4: {
        width: 16.66,
        order_mobile: 4,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: false,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      5: {
        width: 16.66,
        order_mobile: 5,
        rowNo: 1,
        cellGap: {
          top: false,
          right: true,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
        }
      },
      6: {
        width: 16.66,
        order_mobile: 6,
        rowNo: 1,
        cellGap: {
          top: false,
          right: false,
          bottom: true,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      7: {
        width: 16.66,
        order_mobile: 7,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: false,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: true,
            left: true,
          },
        }
      },
      8: {
        width: 16.66,
        order_mobile: 8,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
        }
      },
      9: {
        width: 16.66,
        order_mobile: 9,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: true,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
        }
      },
      10: {
        width: 16.66,
        order_mobile: 10,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: true,
            left: true,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      11: {
        width: 16.66,
        order_mobile: 11,
        rowNo: 2,
        cellGap: {
          top: true,
          right: true,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: true,
            left: false,
          },
          "02": {
            top: true,
            right: true,
            bottom: false,
            left: false,
          },
          "04": {
            top: true,
            right: true,
            bottom: false,
            left: true,
          },
        }
      },
      12: {
        width: 16.66,
        order_mobile: 12,
        rowNo: 2,
        cellGap: {
          top: true,
          right: false,
          bottom: false,
          left: true,
        },
        cellGapMobile: {
          "01": {
            top: true,
            right: false,
            bottom: false,
            left: false,
          },
          "02": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
          "04": {
            top: true,
            right: false,
            bottom: false,
            left: true,
          },
        }
      },
    },
    gridMobile: {
      allowLayout: ["01", "02", "04"],
      gridTemplateColumns: {
        "01": "100%",
        "02": "repeat(2, calc(50% - calc(1 / 2 *  var(--cell-gap))))",
        "04": "repeat(4, calc(25% - calc(3 / 4 * var(--cell-gap))))",
      }
    },
    parents: {
      SECTION_WIDGET_TAB_ITEM: {
        allow: true
      }
    },
  },
};
